// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../../base/types.js';
import { default as _Exchange } from '../../base/PredictionExchange.js';

interface Exchange {
    publicPostInfo (params?: {}): Promise<Dict | List | string>;
    privatePostExchange (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
